import { createContext } from "react";

const LoginModalContext = createContext({
  openLogin: () => {},
});

export default LoginModalContext;
